import * as React from "react";
import SelectBuyer from "../../SelectBuyer/SelectBuyer";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import SelectAgent from "../../SelectAgent/SelectAgent";
import SelectFirm from "../../SelectFirm/SelectFirm";

const BuysideAgent = ({data, handleChangeDropdown, handleChangeInput, addNewItem, newFirm, newAgent, newBuyer, viewMode, deleted, isFinancing}) => {
    return (
        <div className="Buyside-agent">
            <div className="Buyside-agent_column">
                {
                    !isFinancing &&
                    <SelectBuyer
                        className="Buyside-agent_column_item"
                        isFromProperty
                        value={data.BUYER_ID}
                        valueKey="BUYER_ID"
                        label="Buyer"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newBuyer={newBuyer}
                    />
                }
                <SelectTeam
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.BUYER_AGENT_1}
                    valueKey="BUYER_AGENT_1"
                    label="Buyer Agent 1"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <SelectTeam
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.BUYER_AGENT_2}
                    valueKey="BUYER_AGENT_2"
                    label="Buyer Agent 2"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {
                    !isFinancing &&
                    <SelectTeam
                        className="Buyside-agent_column_item"
                        isFromProperty
                        value={data.BUYER_AGENT_3}
                        valueKey="BUYER_AGENT_3"
                        label="Buyer Agent 3"
                        data={data}
                        hasAgentPercent
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                <SelectAgent
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.BUYER_AGENT_4}
                    valueKey="BUYER_AGENT_4"
                    label="Outside Agent"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    withAddNew
                    addNewItem={addNewItem}
                    newAgent={newAgent}
                />
                <SelectFirm
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.BUYER_AGENT_4_FIRM}
                    valueKey="BUYER_AGENT_4_FIRM"
                    label="Buyer Agent Firm"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newFirm={newFirm}
                />
            </div>
        </div>
    );
};

export default BuysideAgent;